import { Options, Vue } from "vue-class-component";

@Options({
    name: "app-model-input",
    props: {
        value: {
            type: [String, Number],
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        submitFunction: {
            type: Function,
            required: true,
        },
        title: {
            type: String,
            default: "修改",
        },
        submitButtonName: {
            type: String,
            default: "提交",
        },
        size: {
            type: String,
            default: "md",
        },
    },
})
export default class ModelInput extends Vue {
    private loading = false;
    private value: string | number = null;
    private curValue: string | number = null;
    private submitFunction: any = null;

    get modValue() {
        return (this.curValue = this.value);
    }

    set modValue(val: any) {
        this.curValue = val;
    }

    public openModal() {
        this.$nextTick(() => {
            (this.$refs.textareaModal as any).openModal();
        }).then();
    }

    public async modFunction(): Promise<any> {
        return await this.submitFunction(this.curValue);
    }
}
